// This replaces Navbar.jsx — same styles, adds cart button with badge
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/logo.png";
import { AnimatePresence, motion } from "framer-motion";
import { useCart } from "../context/CartContext";

const Navbar = ({ onCartClick }) => {
  const [toggle, setToggle] = useState(false);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const handleToggle = () => setToggle(!toggle);
  const [activeTab, setActiveTab] = useState("home");
  const location = useLocation();
  const pathname = location.pathname;
  const [isVisible, setIsVisible] = useState(false);
  const { totalItems } = useCart();

  const closeMobileMenu = () => setToggle(false);

  useEffect(() => {
    if (pathname === "/") setActiveTab("home");
    else if (pathname === "/about-me") setActiveTab("about-me");
    else setActiveTab("");
  }, [pathname]);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => { setToggle(false); }, [pathname]);

  return (
    <>
      <Container className={isVisible ? "visible" : ""}>
        <div className="logo-container">
          <Link to={"/"} className="link-styles" onClick={closeMobileMenu}>
            <img src={logo} alt="Logo" />
          </Link>
        </div>

        <ul className="nav-menu-center">
          <Link to={"/"} className="link-styles">
            <li className={activeTab === "home" ? "activeTab" : "nonActive"}>Home</li>
          </Link>
          <Link to={"/about-me"} className="link-styles">
            <li className={activeTab === "about-me" ? "activeTab" : "nonActive"}>Rreth Nesh</li>
          </Link>
        </ul>

        <div className="nav-buttons">
          <CartBtn onClick={onCartClick}>
            🛒
            {totalItems > 0 && <CartBadge>{totalItems}</CartBadge>}
          </CartBtn>
          <Link to={"/Contact"} className="link-styles">
            <button>Contact</button>
          </Link>
        </div>

        <div className="mobile-right">
          <CartBtn onClick={onCartClick}>
            🛒
            {totalItems > 0 && <CartBadge>{totalItems}</CartBadge>}
          </CartBtn>
          <div className="mobile-menu" onClick={handleToggle}>
            {toggle ? <FaTimes className="icon" /> : <FaBars className="icon" />}
          </div>
        </div>

        <ul className={toggle ? "nav-menu-mobile active" : "nav-menu-mobile"}>
          <Link to={"/"} className="link-styles" onClick={closeMobileMenu}>
            <li className={activeTab === "home" ? "activeTab" : "nonActive"}>Home</li>
          </Link>
          <Link to={"/about-me"} className="link-styles" onClick={closeMobileMenu}>
            <li className={activeTab === "about-me" ? "activeTab" : "nonActive"}>Rreth Nesh</li>
          </Link>
          <Link to={"/contact"} onClick={closeMobileMenu} className="link-styles">
            <button>Contact</button>
          </Link>
        </ul>
      </Container>

      <AnimatePresence>
        {isBookingModalOpen && (
          <ModalOverlay
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setIsBookingModalOpen(false)}
          >
            <ModalContent
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              onClick={(e) => e.stopPropagation()}
            >
              <CloseBtn onClick={() => setIsBookingModalOpen(false)}>&times;</CloseBtn>
              <h3>Info</h3>
            </ModalContent>
          </ModalOverlay>
        )}
      </AnimatePresence>
    </>
  );
};

const CartBtn = styled.button`
  position: relative;
  background: rgba(137,209,70,0.12);
  border: 1px solid rgba(137,209,70,0.25);
  color: white;
  width: 40px; height: 40px;
  border-radius: 50%;
  font-size: 1rem;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all 0.25s ease;
  flex-shrink: 0;
  &:hover { background: rgba(137,209,70,0.25); }
`;

const CartBadge = styled.span`
  position: absolute; top: -4px; right: -4px;
  background: #89d146; color: white;
  font-size: 0.6rem; font-weight: 700;
  width: 16px; height: 16px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-family: 'Montserrat', sans-serif;
`;

const ModalOverlay = styled(motion.div)`
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(109, 99, 87, 0.5); backdrop-filter: blur(8px);
  display: flex; align-items: center; justify-content: center; z-index: 1000; padding: 20px;
`;
const ModalContent = styled(motion.div)`
  background: #fdfcfb; padding: 2.5rem; border-radius: 30px;
  max-width: 450px; width: 100%; text-align: center; position: relative;
  box-shadow: 0 20px 40px rgba(0,0,0,0.2); border: 1px solid #e9e3d0;
  h3 { font-family: 'Playfair Display', serif; font-size: 1.8rem; color: #5a5248; margin-bottom: 0.5rem; }
`;
const CloseBtn = styled.button`
  position: absolute; top: 15px; right: 15px; background: none; border: none;
  font-size: 1.5rem; color: #5a5248; cursor: pointer; opacity: 0.5;
  &:hover { opacity: 1; }
`;

const Container = styled.div`
  position: fixed; top: 1em; left: 50%; transform: translateX(-50%) translateY(-20px);
  width: 80%; height: 60px; padding: 1% 4%;
  display: flex; justify-content: space-between; align-items: center;
  backdrop-filter: blur(7px); -webkit-backdrop-filter: blur(7px);
  background-color: #b6d8764e; border-radius: 30px;
  border: 2px solid #aee0756a; box-shadow: 0 2px 2px 1px #b6e6923e;
  box-sizing: border-box; z-index: 100;
  opacity: 0; transition: opacity 0.5s ease-out, transform 0.5s ease-out;

  &.visible { opacity: 1; transform: translateX(-50%) translateY(0); }

  @media (max-width: 1919px) { width: 90%; }
  @media (max-width: 750px) { width: 90%; }

  .logo-container {
    flex: 1; display: flex; align-items: center;
    img { height: 38px; margin-top: 3px; transition: transform 0.3s ease; filter: brightness(0.4);
      &:hover { transform: scale(1.05); }
      @media (max-width: 600px) { height: 33px; }
    }
  }

  .nav-menu-center {
    flex: 3; display: flex; justify-content: center; gap: 37px;
    list-style: none; margin: 0; padding: 0;
    li { color: #ffffff; font-weight: 400; cursor: pointer; padding: 8px 16px;
      border-radius: 20px; transition: all 0.3s ease; font-family: "Montserrat";
      &:hover { background-color: rgba(109,99,87,0.1); transform: translateY(-2px); }
    }
    .activeTab { text-decoration: underline; text-underline-offset: 7px; font-weight: 600; }
    .link-styles { text-decoration: none; }
  }

  .nav-buttons {
    flex: 1; display: flex; justify-content: flex-end; gap: 12px; align-items: center;
    button { border: none; background: #afd67c; padding: 8px 24px; color: white; font-size: 16px;
      border-radius: 20px; cursor: pointer; font-family: "Comfortaa", sans-serif; transition: all 0.4s ease;
      &:hover { box-shadow: 0 0 14px 2px rgba(109,99,87,0.3); transform: translateY(-2px); }
    }
  }

  .mobile-right {
    display: none; align-items: center; gap: 10px;
    position: absolute; right: 5%;
  }

  .mobile-menu {
    font-size: 24px; cursor: pointer; color: #6d6357; z-index: 9999;
  }

  .nav-menu-mobile {
    background: #f2efe4; width: 90%; height: 100vh;
    position: fixed; top: 0; right: -120%;
    display: flex; flex-direction: column; justify-content: center; align-items: center;
    transition: right 0.3s ease; z-index: 99;
    &.active { right: -10%; }
    li { padding: 15px 30px; margin: 10px 0; border-radius: 25px; cursor: pointer;
      color: #6d6357; list-style: none;
      &:hover { background-color: rgba(109,99,87,0.1); }
    }
    button { border: none; background: #6d6357; padding: 8px 24px; color: white;
      font-size: 16px; border-radius: 20px; cursor: pointer; transition: all 0.4s ease;
      &:hover { box-shadow: 0 0 14px 2px rgba(109,99,87,0.3); transform: translateY(-2px); }
    }
  }

  @media (max-width: 1410px) {
    .nav-menu-center, .nav-buttons { display: none; }
    .mobile-right { display: flex; }
  }
`;

export default Navbar;
